//
// helpers/load-images.js - image loading. promise-based. cancelable.
//

export default function load_image(url) {
  let cancel;

  const load = new Promise((resolve, reject) => {
    cancel = reject;

    const img = document.createElement('img');
    img.onload = () => {
      resolve();
    };
    img.src = url;
  });

  load.cancel = cancel;
  return load;
}
